"use strict";
import React, { forwardRef } from "react";
import classNames from "classnames";
import { observer } from "mobx-react";
var CardTheme = /* @__PURE__ */ ((CardTheme2) => {
  CardTheme2["Dark"] = "dark";
  CardTheme2["Light"] = "light";
  return CardTheme2;
})(CardTheme || {});
function getCardClassName({
  theme,
  className,
  elevation,
  clickable,
  draggable
}) {
  return classNames("card", `card--${theme}`, `card--level-${elevation}`, className, {
    "card--clickable": clickable,
    "card--draggable": draggable
  });
}
const Card = observer(({ theme = "light" /* Light */, className, elevation = 0, ...props }) => {
  return /* @__PURE__ */ React.createElement("div", { className: getCardClassName({ theme, className, elevation }), ...props });
});
const LinkCard = observer(
  ({ theme = "light" /* Light */, className, elevation = 0, target, rel, ...props }) => {
    const defaultRel = target === "_blank" ? "noopener noreferrer" : void 0;
    return /* @__PURE__ */ React.createElement(
      "a",
      {
        className: getCardClassName({ theme, className, elevation, clickable: true }),
        rel: rel || defaultRel,
        target,
        ...props
      }
    );
  }
);
const ButtonCard = observer(
  forwardRef(function ButtonCard2({ theme = "light" /* Light */, className, isDraggable, elevation = 0, ...props }, ref) {
    return /* @__PURE__ */ React.createElement(
      "button",
      {
        className: getCardClassName({ theme, className, clickable: true, draggable: !!isDraggable, elevation }),
        ref,
        ...props
      }
    );
  })
);
export { Card, LinkCard, ButtonCard, CardTheme };
